import { ConfigParam } from '../api';

export interface ConfigModel {
  clientKunde?: string;
  versenderBlockLabel?: string;
  versenderFremdnummerLabel?: string;
  versenderMatchcode: boolean;
  versenderFremdnummer: boolean;
  versenderName: boolean;
  versenderStrasse: boolean;
  versenderOrt: boolean;
  empfaengerMatchcode: boolean;
  empfaengerFremdnummer: boolean;
  empfaengerStrasse: boolean;
  inhalt: boolean;
}

export enum ConfigEnum {
  CLIENT_KUNDE = 'client.kunde',
  VERSENDER_MATCHCODE = 'client.tt.versender.matchcode',
  VERSENDER_FREMDNUMMER = 'client.tt.versender.fremdnummer',
  VERSENDER_BLOCK_LABEL = 'client.tt.versender.block.label',
  VERSENDER_FREMDNUMMER_LABEL = 'client.tt.versender.fremdnummer.label',
  VERSENDER_NAME = 'client.tt.versender.name',
  VERSENDER_STRASSE = 'client.tt.versender.strasse',
  VERSENDER_ORT = 'client.tt.versender.ort',
  EMPFAENGER_MATCHCODE = 'client.tt.empfaenger.matchcode',
  EMPFAENGER_FREMDNUMMER = 'client.tt.empfaenger.fremdnummer',
  EMPFAENGER_STRASSE = 'client.tt.empfaenger.strasse',
  INHALT = 'client.tt.inhalt',
}

export const configParamsToConfigModel = (
  params: ConfigParam[]
): ConfigModel => {
  const configModel: ConfigModel = {
    versenderBlockLabel: undefined,
    versenderFremdnummerLabel: undefined,
    versenderName: true,
    clientKunde: '',
    versenderMatchcode: true,
    versenderFremdnummer: true,
    versenderStrasse: true,
    versenderOrt: true,
    empfaengerMatchcode: true,
    empfaengerFremdnummer: true,
    empfaengerStrasse: true,
    inhalt: true,
  };
  params.forEach(c => {
    switch (c.key) {
      case ConfigEnum.VERSENDER_BLOCK_LABEL: {
        configModel.versenderBlockLabel = c.value;
        break;
      }
      case ConfigEnum.VERSENDER_FREMDNUMMER_LABEL: {
        configModel.versenderFremdnummerLabel = c.value == null ? '' : c.value;
        break;
      }
      case ConfigEnum.VERSENDER_NAME: {
        if (c.value == 'false') {
          configModel.versenderName = false;
        }
        break;
      }
      case ConfigEnum.CLIENT_KUNDE: {
        configModel.clientKunde = c.value;
        break;
      }
      case ConfigEnum.VERSENDER_MATCHCODE: {
        if (c.value == 'false') {
          configModel.versenderMatchcode = false;
        }
        break;
      }
      case ConfigEnum.VERSENDER_FREMDNUMMER: {
        if (c.value == 'false') {
          configModel.versenderFremdnummer = false;
        }
        break;
      }
      case ConfigEnum.VERSENDER_ORT: {
        if (c.value == 'false') {
          configModel.versenderOrt = false;
        }
        break;
      }
      case ConfigEnum.VERSENDER_STRASSE: {
        if (c.value == 'false') {
          configModel.versenderStrasse = false;
        }
        break;
      }
      case ConfigEnum.EMPFAENGER_MATCHCODE: {
        if (c.value == 'false') {
          configModel.empfaengerMatchcode = false;
        }
        break;
      }
      case ConfigEnum.EMPFAENGER_FREMDNUMMER: {
        if (c.value == 'false') {
          configModel.empfaengerFremdnummer = false;
        }
        break;
      }
      case ConfigEnum.EMPFAENGER_STRASSE: {
        if (c.value == 'false') {
          configModel.empfaengerStrasse = false;
        }
        break;
      }
      case ConfigEnum.INHALT: {
        if (c.value == 'false') {
          configModel.inhalt = false;
        }
        break;
      }
    }
  });

  return { ...configModel };
};
